import { Text, VStack } from '@chakra-ui/react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useDropzoneStyles } from '~/components/shared/componentStyles/Dropzone.style'

import { Context } from './Context'

export default function ContentDefault() {
  const { t } = useTranslation()
  const {
    currentVariant,
    props: {
      placeholder = t('contentDefault.placeholder'),
      maxFileSizePlaceholder = '',
    },
  } = useContext(Context)

  const styles = useDropzoneStyles({
    variant: currentVariant,
  })

  return (
    <VStack alignSelf="center" spacing={0}>
      <Text sx={styles.text}>{placeholder}</Text>
      {maxFileSizePlaceholder ? (
        <Text sx={styles.text}>{maxFileSizePlaceholder}</Text>
      ) : null}
    </VStack>
  )
}
